import React from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import Button from '../../../../Components/Button/Button';
import { MonitoringCenterCase } from '../MonitoringCenterListTable/MonitoringCenterListTable';
import useCaseConnect from '../../../Case/Hooks/useCaseConnect';

interface Props {
	item: MonitoringCenterCase;
}

const MonitoringCenterSolvedControlsColumn: React.FC<Props> = ({ item }) => {
	const { handleReassignCase } = useCaseConnect();

	return (
		<Button
			title='base.shared.reconnectWithThePatient'
			theme={Theme.GREEN}
			onClick={() => handleReassignCase(item.id)}
			small
		/>
	);
};

export default MonitoringCenterSolvedControlsColumn;
